import { render, staticRenderFns } from "./organizationalstructure.vue?vue&type=template&id=0983df37&scoped=true&"
import script from "./organizationalstructure.vue?vue&type=script&lang=js&"
export * from "./organizationalstructure.vue?vue&type=script&lang=js&"
import style0 from "./organizationalstructure.vue?vue&type=style&index=0&id=0983df37&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0983df37",
  null
  
)

export default component.exports